import { CompanyResult, CompanyWithResult } from './types/types-company-with-result';
import {
  EntityWithResultCommon,
  OmitEntityCommon,
  OmitResultCommon,
  ResultCommon,
  WithScores,
} from './types/types-entity-with-result-common';
import { ProductResult, ProductWithResult } from './types/types-product-with-result';
import { WeightSetEntityWithResult, WeightSetResult } from './types/types-weight-set-with-result';
import { WeightableEntityWithResult, WeightableEntityWithScores } from './types/types-weightable';

export enum SpecialModelResultId {
  NO_SCORES = -1,
  PRODUCT = -2,
  MIXIN = -3,
}

// OA: A generic interface for results of any ModelEntityType.
// Kept here for backward compatibility, but you should probably use
// one of the interfaces it is extending.
export interface ModelResult
  extends
    ResultCommon,
    OmitResultCommon<ProductResult>,
    OmitResultCommon<CompanyResult>,
    OmitResultCommon<WeightSetResult> {}

// OA: A generic interface for model outputs of any ModelEntityType.
// Kept here for backward compatibility, but you should probably use
// one of the interfaces it is extending.
export interface ModelEntityWithResult
  extends
    EntityWithResultCommon<ModelResult>,
    OmitEntityCommon<ProductWithResult>,
    OmitEntityCommon<CompanyWithResult>,
    OmitEntityCommon<WeightSetEntityWithResult> {
  modelResults: ModelResult[];
}

// OA: A generic type for loading any type of a model entity. See comments above.
export type ModelResultWithScores = WithScores<ModelResult>;

// OA: A generic interface for loading any type of a model entity. See comments above.
export interface ModelEntityWithScores extends ModelEntityWithResult {
  modelResults: ModelResultWithScores[];
}

export interface ModelEntityWithScoresWeightAndEID extends ModelEntityWithScores {
  weight: number | undefined;
  value: number | undefined;
  valueCurrency: string | undefined;
  EID: string | undefined;
}
// OA: This is just forwarding imports to avoid touching many files. TODO: Refactor away.
export type WeightableModelEntityWithScores = WeightableEntityWithScores;

export interface WeightableModelEntitiesByWeightSetId {
  [weightSetId: number]: WeightableEntityWithResult[] | undefined;
}

// OA: As of 10/2021, Companies that have a manual product set get flagged as "standard"
// and the rest are "extended". This flag is used to enable/disable stuff in model entity loading and UI
// NOTE: The string values end up in the external API and API documentation, so editing them needs to be done with care.
export enum CoverageClass {
  STANDARD = 'standard',
  EXTENDED = 'extended',
}

export type ResultContextWithInfo = {
  context: string;
  userGroupId: number;
  userGroupName: string;
  isDefault?: boolean;
};
